import { useLayoutEffect, type RefObject } from 'react';

/** Только для нового образца: запоминает настоящую прокрутку, скрытые вкладки не затирают позицию. */
export function useScrollMemory(ref: RefObject<HTMLElement | null>, key: string) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    let position = { top: 0, left: 0 };
    try {
      const raw = JSON.parse(localStorage.getItem(key) ?? 'null');
      if (raw && Number.isFinite(raw.top) && Number.isFinite(raw.left))
        position = { top: Math.max(0, raw.top), left: Math.max(0, raw.left) };
    } catch {
      /* Новая или недоступная память. */
    }
    el.scrollTo({ top: position.top, left: position.left, behavior: 'instant' });
    const save = () => {
      if (!el.clientHeight || !el.clientWidth || el.closest('[hidden]')) return;
      position = { top: el.scrollTop, left: el.scrollLeft };
      try {
        localStorage.setItem(key, JSON.stringify(position));
      } catch {
        /* Без восстановления. */
      }
    };
    let visible = el.clientHeight > 0 && el.clientWidth > 0;
    const observer = new ResizeObserver(() => {
      const shown = el.clientHeight > 0 && el.clientWidth > 0;
      if (shown && !visible) el.scrollTo({ top: position.top, left: position.left, behavior: 'instant' });
      visible = shown;
    });
    observer.observe(el);
    el.addEventListener('scroll', save, { passive: true });
    return () => {
      save();
      observer.disconnect();
      el.removeEventListener('scroll', save);
    };
  }, [ref, key]);
}
